import { render, staticRenderFns } from "./DialogUsersAndCategoryAddUserUnderCategory.vue?vue&type=template&id=610bd325"
import script from "./DialogUsersAndCategoryAddUserUnderCategory.vue?vue&type=script&lang=js"
export * from "./DialogUsersAndCategoryAddUserUnderCategory.vue?vue&type=script&lang=js"
import style0 from "./DialogUsersAndCategoryAddUserUnderCategory.vue?vue&type=style&index=0&id=610bd325&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports